export const setSessionKey = ({ commit }, key) => {
  commit("SET_SESSION_KEY", key);
};

export const setRoom = ({ commit }, room) => {
  commit("SET_ROOM", room);
};

export const setFormInfo = ({ commit }, form) => {
  commit("SET_FORM_INFO", form);
};

export const setSingleDayPrice = ({ commit }, payload) => {
  commit("SET_SINGLE_DAY_PRICE", payload);
};
